import { useState } from "react";
import { AccountLayout } from "../components/AccountLayout";

export default function AccountPage({ user, setUser, onLogout }) {
    const [form, setForm] = useState({
        name: user?.name || "",
        email: user?.email || "",
        phone: user?.phone || "",
        city: user?.city || "",
        state: user?.state || "",
        pincode: user?.pincode || ""
    });
    const [saved, setSaved] = useState(false);

    const upd = k => e => { setForm(f => ({ ...f, [k]: e.target.value })); setSaved(false); };

    const handleSave = async e => {
        e.preventDefault();

        if (form.phone && !/^\d{10}$/.test(String(form.phone).trim())) {
            alert("Please enter a valid 10-digit phone number.");
            return;
        }
        if (form.pincode && !/^\d{6}$/.test(String(form.pincode).trim())) {
            alert("Please enter a valid 6-digit pincode.");
            return;
        }

        try {
            const res = await fetch("http://localhost:5000/api/users/profile", {
                method: "PUT",
                headers: { 
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${user?.token || ""}`
                },
                body: JSON.stringify(form)
            });
            const data = await res.json();
            if (res.ok) {
                setUser(prev => ({ ...prev, ...data, token: prev.token }));
                setSaved(true);
                setTimeout(() => setSaved(false), 2500);
            } else {
                console.error("Failed to save profile:", data.message);
            }
        } catch (err) {
            console.error("Error saving profile:", err);
        }
    };

    const inputStyle = {
        width: "100%", padding: "13px 16px", borderRadius: 12,
        border: "1.5px solid #f0d0c8", background: "#fff8f8",
        fontFamily: "'Nunito Sans',sans-serif", fontSize: 14,
        outline: "none", color: "#1a0a08", transition: "border-color 0.2s"
    };
    const focusRed = e => e.target.style.borderColor = "#C0392B";
    const blurRed = e => e.target.style.borderColor = "#f0d0c8";

    return (
        <AccountLayout user={user} onLogout={onLogout}>
            <div style={{
                background: "white", borderRadius: 22,
                border: "1.5px solid #f0d0c8",
                padding: 36, animation: "fadeUp 0.4s both",
                boxShadow: "0 4px 18px rgba(192,57,43,0.07)"
            }}>
                {/* Top crimson accent bar */}
                <div style={{ height: 3, background: "linear-gradient(90deg, #C0392B, #E8523A)", borderRadius: "4px 4px 0 0", margin: "-36px -36px 32px" }} />

                {/* Avatar + title */}
                <div style={{ display: "flex", alignItems: "center", gap: 16, marginBottom: 28 }}>
                    <div style={{
                        width: 56, height: 56, borderRadius: "50%",
                        background: "linear-gradient(135deg, #C0392B, #96221A)",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        color: "white", fontFamily: "'Playfair Display',serif",
                        fontWeight: 900, fontSize: 22,
                        boxShadow: "0 4px 14px rgba(192,57,43,0.35)"
                    }}>
                        {(user?.name || "U")[0].toUpperCase()}
                    </div>
                    <div>
                        <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, fontWeight: 800, color: "#1a0a08", marginBottom: 2 }}>My Profile</h2>
                        <p style={{ fontSize: 13, color: "#b07878" }}>Manage your personal information.</p>
                    </div>
                </div>

                <form onSubmit={handleSave}>
                    <style>{`
                        .profile-form-grid {
                            display: grid;
                            grid-template-columns: 1fr 1fr;
                            gap: 18px;
                            margin-bottom: 28px;
                        }
                        @media (max-width: 600px) {
                            .profile-form-grid {
                                grid-template-columns: 1fr !important;
                                gap: 14px !important;
                            }
                        }
                    `}</style>
                    <div className="profile-form-grid">
                        {[["name", "Full Name", "text"], ["email", "Email Address", "email"], ["phone", "Phone Number", "tel"], ["city", "City", "text"], ["state", "State", "text"], ["pincode", "Pin Code", "text"]].map(([k, label, type]) => (
                            <div key={k}>
                                <label style={{ display: "block", fontSize: 12, fontWeight: 700, color: "#7a5550", marginBottom: 6, letterSpacing: "0.02em" }}>{label}</label>
                                <input type={type} value={form[k]} onChange={upd(k)} placeholder={label} style={inputStyle} onFocus={focusRed} onBlur={blurRed} />
                            </div>
                        ))}
                    </div>

                    {/* Divider */}
                    <div style={{ height: "1.5px", background: "linear-gradient(90deg, #f0d0c8, transparent)", marginBottom: 24 }} />

                    <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                        <button
                            type="submit"
                            style={{
                                padding: "13px 32px", fontSize: 14, fontWeight: 700,
                                background: "linear-gradient(135deg, #C0392B, #96221A)",
                                color: "white", border: "none", borderRadius: 10,
                                cursor: "pointer", fontFamily: "'Nunito Sans',sans-serif",
                                boxShadow: "0 4px 16px rgba(192,57,43,0.3)",
                                transition: "all 0.2s"
                            }}
                        >Save Changes</button>
                        {saved && (
                            <span style={{ fontSize: 13, color: "#27ae60", fontWeight: 600, animation: "fadeUp 0.3s both", display: "flex", alignItems: "center", gap: 6 }}>
                                <span style={{ width: 18, height: 18, borderRadius: "50%", background: "#27ae60", color: "white", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 10 }}>✓</span>
                                Profile updated!
                            </span>
                        )}
                    </div>
                </form>
            </div>
        </AccountLayout>
    );
}